// src/services/ClientService.ts

import axios from 'axios';
import { baseUrl } from 'utils/config';

const API_BASE_URL = baseUrl;

export interface Product {
    id: number;
    id2: string;
    category_id: string;
    name: string;
    description: string;
    price: number;
    category: string;
    imageData: string | null;
    imageMimeType: string;
    inStock: boolean;
    numberInStock: number;
    createdAt: string | null;
    updatedAt: string | null;
}

interface SearchParams {
    q?: string;
    min_price?: number;
    max_price?: number;
    category_id?: string;
    skip?: number;
    limit?: number;
}

const api = axios.create({ baseURL: API_BASE_URL });
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers = config.headers || {};
        (config.headers as any).Authorization = `Bearer ${token}`;
    }
    return config;
});

const ClientService = {
    searchProducts: async (params: SearchParams): Promise<Product[]> => {
        try {
            const response = await api.get(`/products/search`, {
                params,
            });
            return response.data.products;
        } catch (error) {
            console.error('Failed to fetch products:', error);
            return [];
        }
    },
};

export default ClientService;
